import { ReactComponent as HomeIcon } from '../../../public/static/sideBar/home.svg';
import { ReactComponent as UserIcon } from '../../../public/static/sideBar/user.svg';
import { ReactComponent as TicketIcon } from '../../../public/static/sideBar/ticket.svg';
import { ReactComponent as MerchantIcon } from '../../../public/static/sideBar/merchant.svg';
import { ReactComponent as MerchantVerIcon } from '../../../public/static/sideBar/verification.svg';
import { ReactComponent as BranchIcon } from '../../../public/static/sideBar/branch.svg';
import { ReactComponent as RegionIcon } from '../../../public/static/sideBar/region.svg';
import { ADMIN_ONLY_ROLE_ORGS, APP_CONSTANTS, USER_LEVEL_TYPES } from '../../URLConstants';
import { useAuth } from '../../components/customContextProviders/AuthContext';

const useSidebarConfig = () => {
  const { isCheckerMakerRequired, userLoginOrg } = useAuth();

  // *** FIXED ORDER ***
  const config = [
    // 1. Dashboard
    {
      title: 'Dashboard',
      path: '/dashboard/soundboxT',
      icon: <HomeIcon />,
      accessRole: [
        APP_CONSTANTS?.USER_ROLE_ADMIN,
        APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN,
        APP_CONSTANTS?.USER_ROLE_L1_SUPPORT,
        APP_CONSTANTS?.USER_ROLE_CHECKER,
        APP_CONSTANTS?.USER_ROLE_MAKER
      ],
      env: ['development', 'sandbox', 'production']
    },

    // 2. Merchants
    {
      title: 'Merchants',
      path: '/dashboard/merchants',
      icon: <MerchantIcon />,
      accessRole: [
        APP_CONSTANTS?.USER_ROLE_ADMIN,
        APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN,
        APP_CONSTANTS?.USER_ROLE_L1_SUPPORT,
        APP_CONSTANTS?.USER_ROLE_CHECKER,
        APP_CONSTANTS?.USER_ROLE_MAKER
      ],
      env: ['development', 'sandbox', 'production']
    },
    {
      title: 'Regions',
      path: '/dashboard/regions',
      icon: <RegionIcon />,
      accessRole: [
      ],
      userLevel: [
        USER_LEVEL_TYPES?.HO
      ],
      env: ['development', 'sandbox', 'production']
    },
    {
      title: 'Branches',
      path: '/dashboard/branches',
      icon: <BranchIcon />,
      accessRole: [
        APP_CONSTANTS?.USER_ROLE_ADMIN,
        APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN,
        APP_CONSTANTS?.USER_ROLE_CHECKER,
        APP_CONSTANTS?.USER_ROLE_MAKER
      ],
      env: ['development', 'sandbox', 'production']
    }
  ];

  config.push({
    title: 'Users',
    path: '/dashboard/organizationusers',
    icon: <UserIcon />,
    accessRole: [APP_CONSTANTS?.USER_ROLE_ADMIN, APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN],
    env: ['development', 'sandbox', 'production']
  });

  // 7. Merchant Verification (Checker/Maker only — not for admin-only-role banks)
  if (isCheckerMakerRequired === 'YES' && !ADMIN_ONLY_ROLE_ORGS.has(userLoginOrg)) {
    config.push({
      title: 'Merchant Verification',
      path: '/dashboard/merchantOnboarding',
      icon: <MerchantVerIcon />,
      accessRole: [
        APP_CONSTANTS?.USER_ROLE_ADMIN,
        APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN,
        APP_CONSTANTS?.USER_ROLE_CHECKER,
        APP_CONSTANTS?.USER_ROLE_MAKER
      ],
      env: ['development', 'sandbox', 'production']
    });
  }

  config.push({
    title: 'Ticket Management',
    path: '/dashboard/ticketmanagement',
    icon: <TicketIcon />,
    accessRole: [
      APP_CONSTANTS?.USER_ROLE_ADMIN,
      APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN,
      APP_CONSTANTS?.USER_ROLE_CHECKER,
      APP_CONSTANTS?.USER_ROLE_MAKER
    ],
    env: ['development', 'production', 'sandbox']
  });

  return config;
};

export default useSidebarConfig;
